// extracted by mini-css-extract-plugin
export default {"container":"scoreTooltip_container__FGy1b","header":"scoreTooltip_header__pT0Kk","text":"scoreTooltip_text__6mLz2"};